import { JSONSchema7 } from 'json-schema';
import { SelectOption } from '../types';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';

export default (currVer: JSONSchema7): JSONSchema7 => {
  const properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 2;

  properties['statusEnabled'] = {
    $id: `${currVer.$id}/statusEnabled`,
    default: false,
    type: 'boolean'
  };

  const currOptions = properties['options'];
  (currOptions.default as unknown as SelectOption[]).forEach((option) => {
    option.status = '';
  });

  properties['options'] = currOptions;

  return {
    ...currVer,
    properties
  };
};
